import './index.scss';

export const FlutuacaoMoedas = () => {

    return (
        <div className='dados-empresa' style={{backgroundColor:"#F8F8F9"}}>
        <div>
            <div>
                <h1>
                    A flutuação das moedas estrangeiras não precisa ser um problema para seu negócio.
                </h1>
                <p>
                    Ao se proteger contra os riscos cambiais, a empresa pode se concentrar em suas atividades principais, sem a preocupação
                    constante com a flutuação das moedas. Nossos produtos permitem que sua empresa tenha previsibilidade de custos,
                    proteção contra desvalorização de moedas e maior competitividade.
                </p>
            </div>
                <div className='buttons-style'>
                    <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                </div>
                
            </div>
        </div>
    )
}

